import Vue from 'vue';
import VueI18n from 'vue-i18n';
import nl from '@/locales/nl.json';
import fr from '@/locales/fr.json';
import en from '@/locales/en.json';

Vue.use(VueI18n);

// Get saved language from localStorage or default to 'nl'
const savedLocale = localStorage.getItem('locale') || 'nl';

export const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'nl',
  messages: {
    nl,
    fr,
    en,
  },
});


// Keep <html lang> in sync with the active locale so browsers never guess
// the page language (and offer/auto-apply a machine translation).
const syncHtmlLang = (locale: string) => {
  document.documentElement.setAttribute('lang', locale);
};
syncHtmlLang(savedLocale);
// `vm` exists at runtime but is missing from the vue-i18n v8 typings.
(i18n as unknown as { vm: Vue }).vm.$watch('locale', syncHtmlLang);
